import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { ThosAddAccountParameter } from "@thos/Handlers/ThosAddAccount";
import { ThosAccountNumberValidation, ThosAddAccountModel } from "@thos/Services/ThosApiModels";

export async function thosValidateAccountNumber(
    model: ThosAccountNumberValidation,
): Promise<ServiceResult<boolean>> {
    try {
        const result = await post<ThosAccountNumberValidation, boolean>(
            "/api/v1/ThosAccount/validate-account-number",
            model,
        );
        if (result === true) {
            return {
                result,
                successful: true,
            };
        }
        return {
            successful: false,
            errorMessage: "Invalid combination",
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: "Invalid combination",
        };
    }
}

export async function thosAddAccount(parameter: ThosAddAccountParameter): Promise<ServiceResult<string>> {
    const accountAddModel: ThosAddAccountModel = {
        isNewCustomer: parameter.accountInfo.isNewCustomer,
        accountNumber: parameter.accountInfo.accountNumber,
        firstName: parameter.accountInfo.firstName,
        lastName: parameter.accountInfo.lastName,
        companyName: parameter.accountInfo.companyName,
        emailAddress: parameter.email,
        address1: parameter.accountInfo.address1,
        address2: parameter.accountInfo.address2,
        city: parameter.accountInfo.city,
        postalCode: parameter.accountInfo.postalCode,
        phoneNumber: parameter.accountInfo.phoneNumber,
        country: parameter.accountInfo.country,
        state: parameter.accountInfo.state,
        faxNumber: parameter.accountInfo.faxNumber,
        uri: "",
        properties: {
        },
    };
    const accountModel = await post<ThosAddAccountModel, string>(
        "/api/v1/ThosAccount/update-account",
        accountAddModel,
    );
    return {
        result: accountModel,
        successful: true,
    };
}
